import React, { useState } from 'react'
import { useMutation } from '@apollo/client'
import { ADD_COMMENT } from '../../utils/constants/mutations';
import { GET_BLOG_CATEGORY_POSTS } from '../../utils/constants/queries';

export default function AddComment(props) {
    const [addCommentMutation] = useMutation(ADD_COMMENT);
    const postId = props.post
    const [comment, setComment] = useState('')
    const [email, setEmail] = useState('')
    const [username, setName] = useState('')
    const [website, setWebsite] = useState('')
    const submitComment = (event) => {
        event.preventDefault();
        console.log({ comment, email, username, website, postId })
        addCommentMutation({
            variables: {
                        comment,
                    username,
                    email,
                    blog:postId,
                
            },
            
            update: (cache,{data:{ADD_COMMENT}}) => {
                       try {const existingComments = cache.readQuery({ query: GET_BLOG_CATEGORY_POSTS,variables:{
                        variables: {
                            blogId: postId,
                        },
                       } });
                        const newComments = existingComments.comments.push(ADD_COMMENT)
                        cache.writeQuery({
                          query: GET_BLOG_CATEGORY_POSTS,
                          data: {comments: newComments,comments_aggregate:existingComments.comments_aggregate+1}
                        });
                           
                       } catch (error) {
                        console.log(error);
                        console.log("Not updating store - Projects not loaded yet");
                       }
                      }
                 
        });

    }

    return (
        <div className="comment-respond">
            <h3 className="comment-reply-title">Leave a Reply</h3>
            <form className="comment-form" onSubmit={submitComment}>
                <p className="comment-notes">
                    <span id="email-notes">Your email address will not be published.</span>
                                    Required fields are marked
                     <span className="required">*</span>
                </p>
                <p className="comment-form-comment">
                    <label>Comment</label>
                    <textarea name="comment" id="comment" cols="45" rows="5" maxlength="65525" required="required" onChange={e => setComment(e.target.value)}></textarea>
                </p>
                <p className="comment-form-author">
                    <label>Name <span className="required">*</span></label>
                    <input type="text" id="author" name="author" required="required" onChange={e => setName(e.target.value)} />
                </p>
                <p className="comment-form-email">
                    <label>Email <span className="required">*</span></label>
                    <input type="email" id="email" name="email" required="required" onChange={e => setEmail(e.target.value)} />
                </p>
                <p className="comment-form-url">
                    <label>Website</label>
                    <input type="url" id="url" name="url" onChange={e => setWebsite(e.target.value)} />
                </p>
                <p className="comment-form-cookies-consent">
                    <input type="checkbox" value="yes" name="wp-comment-cookies-consent" id="wp-comment-cookies-consent" />
                    <label for="wp-comment-cookies-consent">Save my name, email, and website in this browser for the next time I comment.</label>
                </p>
                <p className="form-submit">
                    <input type="submit" name="submit" id="submit" className="submit" value="Post A Comment" />
                </p>
            </form>
        </div>

    )
}
